import {LeadCommentModel,LeadModel, SuperBit_swaggerClient,RenewalPrices,LeadFilterModel, PolicyFilterModel,RenewalsSalespersonPolicies, RenewalsFilterModel,RenewalsConfigData} from './superbit-api-models';
import generalSettings from '../json/general-settings.json';

export class ProductionModel {
    client:any;
    constructor() {
        this.init();
    }

    async fetchData () {
        let apiUrl = undefined;
        try {
            const response = await fetch('/config.json');
            const jsonData = await response.json();
            apiUrl = jsonData.apiUrl;
            localStorage.setItem('apiUrl', apiUrl)
            localStorage.setItem('appConfig', JSON.stringify(jsonData));
        } catch (error) {
            console.error('Error fetching data: ', error);
        }
        return apiUrl;
    };


    async init () {
        let apiUrl = localStorage.getItem('apiUrl');
        if (!apiUrl) {
            apiUrl = await this.fetchData();
        }
        var url = apiUrl ? apiUrl : generalSettings.apiUrl;
        //var url = "https://localhost:44333";
        //this.client = new SuperBit_swaggerClient("http://api.dev-alt.superbit.co.il");
        this.client = new SuperBit_swaggerClient(url);//(settings.apiUrl);
    }
    

    async DownloadProductionFilesSholomo () {
        return await this.client.DownloadProductionFilesSholomo();
        
    };

    async SetToken (token:string) {
         return await this.client.SetToken(token);
        
    };

    async GetShlomoStatus () {
        return await this.client.GetShlomoStatus();
        
    };

    async GetProductionStatus () {
        return await this.client.GetProductionStatus();
        
    };

    async GetSigningDocuments (id:string) {
        return await this.client.GetSigningDocuments(id);
        
    };

    async GetSigningData (id:string) {
        return await this.client.GetSigningData(id);        
    };

    async PrintPolicy (id:string) {
        let url = await this.client.PrintPolicy(id);        
        return await this.fetchData()+url;
    };

    async GetSigningCounter () {
        return await this.client.GetSigningCounter();        
    };

    async UploadFile2(obj: any) {
        return await this.client.documentsUploadFile2(obj);
    }

    
    async GetFilesDetails () {
        return await this.client.getFilesDetails();        
    };

    async policyReadProductionFile (content_: FormData) {
        return await this.client.policyReadProductionFile2(content_);        
    };

    
    
}